import {find} from 'lodash';
import {isQuickPlanningRow} from "./Profile/rowQualifier";

export const findQuickPlanningRow = <T extends StatementRow|StatementDeepTimeSeriesRow>(s: T[]): T | undefined => find(s, isQuickPlanningRow);

export const findRow = <T extends StatementRow|StatementDeepTimeSeriesRow>(rows: T) => {}
